import React from 'react';

interface ExportPdfIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

/** Figma export PDF glyph (public/images/ExportPDF.svg). */
const ExportPdfIcon: React.FC<ExportPdfIconProps> = ({
  width = 16,
  height = 16,
  className
}) => {
  return (
    <img
      src="/images/ExportPDF.svg"
      alt=""
      width={width}
      height={height}
      className={className}
      aria-hidden="true"
      draggable={false}
    />
  );
};

export default ExportPdfIcon;
